import React from "react"
import UserBuilderGeneral from "./tabs/UserBuilderGeneral"
import UserBuilderRoles from "./tabs/UserBuilderRoles"
import UserBuilderHistory from "./tabs/UserBuilderHistory"
import UserBuilderProperties from "./tabs/UserBuilderProperties"


export default class UserBuilderWorkspace extends React.Component {


    constructor(props) {
      super(props)
    }

    render() {
      return (
        <div className="tab-content">
          <UserBuilderGeneral {...this.props} /* print_button={true} */ />
          <UserBuilderRoles {...this.props} /* print_button={true} */ />
          {this.props.read_only ? <UserBuilderHistory {...this.props} /* print_button={true} */ /> : null}
        </div>
      )
    }

};
